import { useSignIn } from "./index.hook";
import styles from "./index.module.less";
import SignInForm from "./SignInForm";
import RequestPasswordReset from "./RequestPasswordReset";
import { CustomerSideNextScreenConstants } from "../../constants/generalConstants";
import UpdatePassword from "./UpdatePassword";
import CommonModal from "../common/Modal";

const SignIn = () => {
  const config = useSignIn();

  return (
    <>
      <div className={`gx-app-login-wrap gx-screen-zoom-signin`}>
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <img alt="Wipro-PARI" src={`${process.env.PUBLIC_URL}/assets/images/wipro-pari-image.png`} />
            </div>
            <div className={`gx-app-login-content ${styles["signIn-form"]}`}>
              <span className={styles["signIn-description"]}>Welcome to parkdux</span>

              {!config.nextScreen && <SignInForm handleSubmit={config.handleSubmit} handleForgotPasswordScreen={config.handleForgotPasswordScreen} loading={config.loading} />}
              {config?.nextScreen === CustomerSideNextScreenConstants.FORGOT_PASSWORD && <RequestPasswordReset nextScreenHelper={config.nextScreenHelper} handleNextScreen={config.handleNextScreen} />}
              {config?.nextScreen === CustomerSideNextScreenConstants.UPDATE_PASSWORD && <UpdatePassword nextScreenHelper={config.nextScreenHelper} handleNextScreen={config.handleNextScreen} />}

              <div className={styles["signIn_footer"]}>
                <span className={styles["signIn_footer-text"]}>Powered By</span>
                <img alt="logo" src={`${process.env.PUBLIC_URL}/assets/images/wipro-pari-logo.png`} className={`${styles["adani-logo"]}`} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CommonModal resetModal={config.handleUserActiveOk} showModal={!config.isUserActive} modalMessage={"Due to inactivity your session is expired, please login again."} title="Message" />
      <CommonModal resetModal={config.handleTokenExpiredOk} showModal={config.isTokenExpired} modalMessage={"Your session is expired, please login and retry."} title="Message" />
    </>
  );
};

export default SignIn;
